import React from "react";
import ReactDOM from "react-dom/client";
import { RouterProvider } from "react-router-dom";
import { WagmiProvider } from "wagmi";
import { QueryClient, QueryClientProvider } from "@tanstack/react-query";
import { RainbowKitProvider, lightTheme, darkTheme } from "@rainbow-me/rainbowkit";
import "@rainbow-me/rainbowkit/styles.css";
import "./index.css";
import { wagmiConfig } from "./lib/wagmi";
import { router } from "./router";
import { useThemeStore } from "./stores/theme";

const queryClient = new QueryClient();

function ThemedRainbow({ children }: { children: React.ReactNode }) {
  const resolved = useThemeStore((s) => s.resolved);
  return (
    <RainbowKitProvider
      theme={
        resolved === "dark"
          ? darkTheme({ borderRadius: "medium" })
          : lightTheme({ borderRadius: "medium" })
      }
    >
      {children}
    </RainbowKitProvider>
  );
}

ReactDOM.createRoot(document.getElementById("root")!).render(
  <React.StrictMode>
    <WagmiProvider config={wagmiConfig}>
      <QueryClientProvider client={queryClient}>
        <ThemedRainbow>
          <RouterProvider router={router} />
        </ThemedRainbow>
      </QueryClientProvider>
    </WagmiProvider>
  </React.StrictMode>,
);
